import { CLASS_CONSTRUCTOR_DEPS } from '../metadata/metadata-keys';
import { MetadataHandler } from '../metadata/metadata-handler';
import { addTypeParameterMeta } from '../metadata/add-parameter-meta';
/**
 * 用于获取构造函数的依赖
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class DependencyResolver {
    /**
     * 为构造函数添加依赖
     * @param annotationTarget
     * @param identifier
     * @param parameterIndex
     */
    static addServiceDependencies(annotationTarget, identifier, parameterIndex) {
        addTypeParameterMeta(CLASS_CONSTRUCTOR_DEPS, annotationTarget, undefined, identifier, parameterIndex);
    }
    /**
     * 获取构造函数的依赖关系数组
     * @param target
     * @returns IServiceDependency 依赖关系数组
     */
    static getServiceDependencies(target) {
        const targetDeps = [];
        const targetMetadata = MetadataHandler.getDepsMetadata(CLASS_CONSTRUCTOR_DEPS, target);
        if (!targetMetadata) {
            return targetDeps;
        }
        Object.keys(targetMetadata).forEach((indexKey) => {
            const requestMeta = targetMetadata[indexKey];
            if (requestMeta[1]) {
                // 一个参数只支持一个依赖，目前只拿第一个依赖
                targetDeps.push({
                    id: requestMeta[1].serviceIdentifier,
                    index: parseInt(indexKey, 10),
                    query: requestMeta[1],
                });
            }
            else if (requestMeta[0]) {
                targetDeps.push({
                    id: requestMeta[0],
                    index: parseInt(indexKey, 10),
                    query: {
                        serviceIdentifier: requestMeta[0],
                    },
                });
            }
        });
        return targetDeps;
    }
}
//# sourceMappingURL=dependency-resolver.js.map